import {
  createFileRoute,
  useNavigate,
  useLocation,
  useParams
} from '@tanstack/react-router'
import AssigneeView from '../../../../../../../../../../../../../containers/tasks/components/task-assignee-view/assignee-view/index.jsx'
import { useGetTaskQuery } from '../../../../../../../../../../../../../react-query/tasks/query/use-get-task-query.jsx'
import { useTaskHandler } from '../../../../../../../../../../../../../containers/tasks/hooks/use-task-handler.jsx'

function ChangeAssigneeRouteComponent() {
  const navigate = useNavigate()
  const location = useLocation()
  const { taskId } = useParams({ strict: false })
  const { data: taskDetails } = useGetTaskQuery(taskId)

  const taskDetailsPath = location.pathname.replace(/\/change-assignee\/?$/, '')
  const pinPath = taskDetailsPath.split('/task')[0]
  const isReassign = location.state?.isReassign

  const { handleSetAssignee, isPendingUpdateTask } = useTaskHandler(
    pinPath,
    taskDetailsPath,
    isReassign
  )

  const handleClose = () => {
    navigate({ to: taskDetailsPath, search: (prev) => prev })
  }

  return (
    <AssigneeView
      onClose={handleClose}
      handleSetAssignee={handleSetAssignee}
      isLoading={isPendingUpdateTask}
      defaultValue={taskDetails?.assignment ?? {}}
    />
  )
}

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/'
)({
  component: ChangeAssigneeRouteComponent
})
